export function throttle(callback: (...args: any[]) => any, interval: number) {
  let allow = true;
  let handler: any;

  return (...args: any[]) => {
    if (!allow) {
      return;
    }

    allow = false;
    // @ts-ignore
    callback.apply(this, args);
    clearTimeout(handler);
    handler = setTimeout(() => {
      allow = true;
    }, interval);
  };
}
